  import React from 'react'
import { SeguroEncomenda } from './SeguroEncomenda'

export default class DetalheEncomenda extends React.Component {
  render () {
    if (!this.props.encomenda.exibirDetalhe) {
      return ''
    }
    return (
      <div className="card-body cinza-zebrado">
        <div className="row m-2 border-bottom">
           <div className="col-md-3">
             <p><strong>Cidade origem:</strong> {this.props.encomenda.cidadeOrigem}</p>
           </div>
           <div className="col-md-3">
             <p><strong>Cidade destino:</strong> {this.props.encomenda.cidadeDestino}</p>
           </div>
          <div className="col-md-2">
            <p><strong>Data da partida:</strong> {this.props.encomenda.dataHoraPartida}</p>
          </div>
          <div className="col-md-3">
            <p><strong>Data da chegada:</strong> {this.props.encomenda.dataHoraChegada}</p>
          </div>
          <div className="col-md-1">
            <p><strong>Rota:</strong> {this.props.encomenda.rotaId}</p>
          </div>
          <div className="col-md-4">
            <strong>Remetente: </strong><span>{this.props.encomenda.remetente.nome}</span><br/>
            <strong>E-mail: </strong><span>{this.props.encomenda.remetente.email}</span><br/>
            <strong>Telefone: </strong><span>{this.props.encomenda.remetente.telefone}</span><br/>
            <strong>CPF: </strong><span>{this.props.encomenda.remetente.cpfCnpj}</span><br/>
            <span>{`${this.props.encomenda.enderecoRemetente.logradouro}, ${this.props.encomenda.enderecoRemetente.numero ? this.props.encomenda.enderecoRemetente.numero : 'S/N'}${this.props.encomenda.enderecoRemetente.complemento ? `, ${this.props.encomenda.enderecoRemetente.complemento}` : ''}`}</span><br/>
            <span>{`${this.props.encomenda.enderecoRemetente.bairro} - ${this.props.encomenda.enderecoRemetente.localidade} - ${this.props.encomenda.enderecoRemetente.uf}`}</span><br/>
            CEP: <span>{this.props.encomenda.enderecoRemetente.cep}</span>
          </div>
          <div className="col-md-4">
            <strong>Destinatario: </strong><span>{this.props.encomenda.destinatario.nome}</span><br/>
            <strong>E-mail: </strong><span>{this.props.encomenda.destinatario.email}</span><br/>
            <strong>Telefone: </strong><span>{this.props.encomenda.destinatario.telefone}</span><br/>
            <strong>CPF: </strong><span>{this.props.encomenda.destinatario.cpfCnpj}</span><br/>
            <span>{`${this.props.encomenda.enderecoRemetente.logradouro}, ${this.props.encomenda.enderecoRemetente.numero ? this.props.encomenda.enderecoRemetente.numero : 'S/N'}${this.props.encomenda.enderecoRemetente.complemento ? `, ${this.props.encomenda.enderecoRemetente.complemento}` : ''}`}</span><br/>
            <span>{`${this.props.encomenda.enderecoRemetente.bairro} - ${this.props.encomenda.enderecoRemetente.localidade} - ${this.props.encomenda.enderecoRemetente.uf}`}</span><br/>
            CEP: <span>{this.props.encomenda.enderecoRemetente.cep}</span>
          </div>
          <div className="col-md-4">
            <strong>Forma de pagamento: </strong><span>{this.props.encomenda.descricaoFormasPagamento}</span><br/>
            <strong>Tipo de cálculo utilizado: </strong><span>{this.props.encomenda.descricaoTipoCalculo}</span><br/>
            <SeguroEncomenda encomenda={this.props.encomenda} />
          </div>
          <div className="col-md-8 mt-2">
            <p><strong>Ponto de embarque:</strong> {this.props.encomenda.embarque}</p>
          </div>
        </div>
      </div>
    )
  }
}
